import * as React from "react";
import initialState from "./state";

const PlannerContext = React.createContext(initialState as any)
PlannerContext.displayName = 'Planner'

export default PlannerContext;
